import React from 'react';
import { connect } from 'react-redux';

import Sticky from 'Components/Sticky';
import RFQCard from 'Components/RFQCard';
import ActionLoader from 'Components/ActionLoader';

import { DOWNLOAD_RFQ_TEMPLATE, UPLOAD_RFQ, CREATE_FRESH_RFQ } from 'Constants/actionConstants';

import RFQ from 'Models/RFQ';

import { SINGLE_MODE, MULTI_MODE, SECONDARY_MODE, COURIER_RFQ_TYPE, EXIM_RFQ_TYPE, AWL_MULTI_MODE, RIL_WAREHOUSE, GENERAL_PROCUREMENT, DISPOSAL_PRODUCT, EMAMI, CARGIL, DEEPAK_PHENOLICS_SAP, DEEPAK_PHENOLICS, CONTAINER_RFQ } from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';
import ResponsiveTable from 'Components/ResponsiveTable';
import { isAdaniWilmar } from 'Utils/';
import SubRFQCard from 'Components/SubRFQCard';

class Home extends React.Component {
   state = {
      link: '',
      showLoader: false
   }
   linkRef = React.createRef();
   createRFQ = (type) => {
      const user = getUser();
      if(type === 5 && user.rfqTypes.find(el => [12,13,14,15].includes(el))) {
         this.setState({ showSubRFQTypes: true });
      } else {
         this.setState({ showLoader: true });
         const { dispatch } = this.props;
         const rfq = new RFQ();
         rfq.seRFQType(type);
         if(type === 4) {
            rfq.rfqDetails.setServiceType(3, 'Courier');
         }
         if([5, 13, 14, 15].includes(type)) {
            rfq.rfqDetails.setMultiLevelMovementType(1);
            rfq.rfqDetails.setShippingType(1);
            rfq.rfqDetails.setServiceType(4, 'Container');
            rfq.biddingDetails.setPricingBasis({ value: 13, name: 'Rate per container' });
            if([13,14,15].includes(type)) {
               rfq.rfqDetails.setOtherCosts(true);
            }
         }
         if(type === 12) {
            rfq.rfqDetails.setShippingType(1);
         }
         // if(type === 6) {
         //    rfq.rfqDetails.setServiceType(4);
         // }
         if(type !== 1 && type !== 12) {
            rfq.rfqDetails.setServiceModes([]);
         }
         if(type === 9) {
            rfq.rfqDetails.setAcceptPartialSolution(false);
            rfq.rfqDetails.setContractTenureTo(new Date().setHours(0, 0, 0, 0));
         }
         dispatch({
            type: CREATE_FRESH_RFQ,
            rfq: rfq.getApiData()
         });
      }
   }
   downloadRFQTemplate = (params) => {
      const { dispatch } = this.props;
      dispatch({
         type: DOWNLOAD_RFQ_TEMPLATE,
         params,
         onSuccess: (data) => {
            this.setState({
               link: data.link
            }, () => {
               this.linkRef.current.click();
            })
         }
      })
   }
   uploadRFQ = (file, params) => {
      const { dispatch } = this.props;
      dispatch({
         type: UPLOAD_RFQ,
         file,
         params
      })
   }

   render() {
      const { downloadingTemplate, uploadingTemplate } = this.props;
      const { showLoader } = this.state;
      const user = getUser();
      return (
         <Sticky>
            {downloadingTemplate && <ActionLoader fixed={true} />}
            {uploadingTemplate && <ActionLoader fixed={true} />}
            {showLoader && <ActionLoader fixed={true} />}
            {!showLoader && !this.state.showSubRFQTypes &&
               <ResponsiveTable>
                  <div className="fBold fs-30 tCenter mb-30 mt-30">Choose Your RFQ Form</div>
                  
                  <div className="flex flex-center flex-wrap">
                     {user.rfqTypes && user.rfqTypes.indexOf(SINGLE_MODE) > -1 && <RFQCard uploadRFQ={this.uploadRFQ} downloadRFQTemplate={this.downloadRFQTemplate} createRFQ={this.createRFQ.bind(this, SINGLE_MODE)} type={SINGLE_MODE} />}
                     {user.rfqTypes && user.rfqTypes.indexOf(MULTI_MODE) > -1 && !isAdaniWilmar() &&  <RFQCard uploadRFQ={this.uploadRFQ} downloadRFQTemplate={this.downloadRFQTemplate} createRFQ={this.createRFQ.bind(this, MULTI_MODE)} type={MULTI_MODE} />}
                     {user.rfqTypes && user.rfqTypes.indexOf(SECONDARY_MODE) > -1 && <RFQCard uploadRFQ={this.uploadRFQ} downloadRFQTemplate={this.downloadRFQTemplate} createRFQ={this.createRFQ.bind(this, SECONDARY_MODE)} type={SECONDARY_MODE} />}
                     {user.rfqTypes && user.rfqTypes.indexOf(COURIER_RFQ_TYPE) > -1 && <RFQCard uploadRFQ={this.uploadRFQ} downloadRFQTemplate={this.downloadRFQTemplate} createRFQ={this.createRFQ.bind(this, COURIER_RFQ_TYPE)} type={COURIER_RFQ_TYPE} />}
                     {user.rfqTypes && user.rfqTypes.indexOf(EXIM_RFQ_TYPE) > -1 && <RFQCard uploadRFQ={this.uploadRFQ} downloadRFQTemplate={this.downloadRFQTemplate} createRFQ={this.createRFQ.bind(this, EXIM_RFQ_TYPE)} type={EXIM_RFQ_TYPE} />}
                     {user.rfqTypes && user.rfqTypes.indexOf(AWL_MULTI_MODE) > -1 && (isAdaniWilmar() || [...EMAMI, ...CARGIL].includes(user.companyId)) &&  <RFQCard uploadRFQ={this.uploadRFQ} downloadRFQTemplate={this.downloadRFQTemplate} createRFQ={this.createRFQ.bind(this, AWL_MULTI_MODE)} type={AWL_MULTI_MODE} />}
                     {user.rfqTypes && user.rfqTypes.indexOf(DISPOSAL_PRODUCT) > -1 && user.is_disposal_access && <RFQCard uploadRFQ={this.uploadRFQ} downloadRFQTemplate={this.downloadRFQTemplate} createRFQ={this.createRFQ.bind(this, DISPOSAL_PRODUCT)} type={DISPOSAL_PRODUCT} />}
                     {user.rfqTypes && user.rfqTypes.indexOf(CONTAINER_RFQ) > -1 && <RFQCard uploadRFQ={this.uploadRFQ} downloadRFQTemplate={this.downloadRFQTemplate} createRFQ={this.createRFQ.bind(this, CONTAINER_RFQ)} type={CONTAINER_RFQ} />}
                  </div>
                  <a ref={this.linkRef} className="dNone" href={this.state.link}>Link</a>
               </ResponsiveTable>
            }
            {this.state.showSubRFQTypes && 
               <SubRFQCard 
                  onClickRFQ={this.createRFQ}
               />}
         </Sticky>
      );
   }
}

const mapStateToProps = ({ rfq }) => {
   return {
      downloadingTemplate: rfq.downloadTemplates.dataSubmitting,
      uploadingTemplate: rfq.uploadTemplates.dataSubmitting,
   }
};


export default connect(mapStateToProps)(Home);